import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// RX-JS
import { BehaviorSubject } from 'rxjs';

// EMS
import {
  CurrencyType,
  FacetResponse,
  OriginType,
  ProductDetailsEMS,
  ProductImage,
  SearchRequest,
  SearchResultWithFacets,
  SearchSort,
} from '../../../@utils';
import { environment } from '../../../../environments/environment';

export interface IProduct {
  Details: ProductDetailsEMS;
  Images: ProductImage[];
}

@Injectable()
export class ElasticSearchService {
  url: string;

  private _facets$ = new BehaviorSubject<FacetResponse>(null);
  public facets$ = this._facets$.asObservable();

  private _searchResults$ =
    new BehaviorSubject<SearchResultWithFacets>(null);
  public searchResult$ = this._searchResults$.asObservable();

  constructor(
    private _http: HttpClient,
  ) {
    this.url = environment.esServerUrl;
  }

  public search(keywords: string, token: string) {
    const request: SearchRequest = {
      Keywords: keywords,
      SupplierIDs: undefined,
      StringFacets: undefined,
      NumberFacets: undefined,
      Sort: SearchSort.Relevant,
      Currency: CurrencyType.Native,
      Origin: OriginType.NoPreference,
      Page: 1
    };
    
    return this._http
      .post<SearchResultWithFacets>(this.url + 'Search', request, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  }

  public getPageOfProducts(request: SearchRequest, token: string): void {
    this._http
      .post<SearchResultWithFacets>(this.url + 'Search', request, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      // eslint-disable-next-line rxjs/no-ignored-subscription, rxjs/no-ignored-error
      .subscribe({
        next: (response: SearchResultWithFacets) =>
          this._searchResults$.next(response),
      });
  }

  public getProduct(commonDetailID: number, token: string) {
    const params = {
      CommonDetailID: String(commonDetailID)
    };
    return this._http.get<IProduct>(`${this.url}Product`, { params, headers: { Authorization: `Bearer ${token}` } });
  }

  public getFacets(request: SearchRequest): void {
    this._http
      .post<FacetResponse>(this.url + 'Facets', request)
      // eslint-disable-next-line rxjs/no-ignored-subscription, rxjs/no-ignored-error
      .subscribe({
        next: (response: FacetResponse) =>
          this._facets$.next(response),
      });
  }
}
